import { createTheme } from '@mui/material/styles';

/**
 * Design System "3 corazones" - Edición Scrapbook Premium.
 */
export const theme = createTheme({
  cssVariables: true,
  palette: {
    primary: {
      main: '#D4AF37', // Dorado Antiguo
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#FFB7C5', // Rosa Pétalo
      light: '#FFF0F5',
      dark: '#E08EA0',
      contrastText: '#2D2D2D',
    },
    background: {
      default: '#FFFAF9',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#333333',
      secondary: '#666666',
    },
  },
  typography: {
    fontFamily: '"Montserrat", "Playfair Display", sans-serif',
    h1: {
      fontFamily: '"Dancing Script", cursive',
      fontWeight: 700,
      fontSize: '5rem',
      color: '#E08EA0', // Rosa más oscuro para h1 animado
    },
    h2: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 700,
      color: '#E08EA0',
      letterSpacing: 1,
    },
    h3: {
      fontFamily: '"Dancing Script", cursive',
      fontWeight: 700,
      fontSize: '3.5rem',
    },
    h4: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 900,
    },
    h5: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 700,
      letterSpacing: 3,
    },
    body1: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 500,
    },
    body2: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 50,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 50,
          padding: '12px 35px',
          fontFamily: '"Montserrat", sans-serif',
          fontWeight: 700,
          textTransform: 'none',
        },
      },
    },
  },
});
